// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/skeleton/style/index.less
// module id = 1807
// module chunks = 0